module.exports = __webpack_public_path__ + "static/media/Care Grid.b64d537e.png";